import { render, staticRenderFns } from "./page-loading.vue?vue&type=template&id=1fdf35f7"
import script from "./page-loading.vue?vue&type=script&lang=ts"
export * from "./page-loading.vue?vue&type=script&lang=ts"
import style0 from "./page-loading.vue?vue&type=style&index=0&id=1fdf35f7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports